import React, { Component } from "react";
import { GET, POST, tokens, loading, profile, alert, t } from "../components/CustomComponent.js";
import Language from "../components/Language.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import { clearStorageKeepLang } from "../utils/backendMessage";

export default class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_profile: profile || null,
      searchName: "",
      selectedCompany: null,
      rememberMe: false,
      // ข้อมูลบริษัทจำลอง (สามารถเปลี่ยนให้เป็นการดึงจาก API ได้)
      companies: [],
      // uid ของบริษัทที่โหลดรูปโลโก้ไม่สำเร็จ (ลิงก์เสีย/ไฟล์หาย) - ให้ตกกลับไปใช้ไอคอนตึก
      logoErrors: {},
    };
  }

  // ไอคอนหน้าการ์ดบริษัท: มีโลโก้ใช้โลโก้ ไม่มี (หรือโหลดไม่ขึ้น) ใช้ไอคอนตึกเหมือนเดิม
  renderCompanyIcon = (company, size, iconStyle) => {
    const showLogo = company.logo && !this.state.logoErrors[company.id];
    if (showLogo) {
      return (
        <img
          src={company.logo}
          alt={company.name}
          style={{ width: size, height: size, objectFit: "contain" }}
          onError={() => this.setState((prev) => ({ logoErrors: { ...prev.logoErrors, [company.id]: true } }))}
        />
      );
    }
    return <span className="icon" style={iconStyle}>{"\uf1ad"}</span>;
  };

  componentDidMount() {
    loading(false);
    this.GetProfile();
    this.GetCompanies(); // เรียกฟังก์ชันดึงข้อมูลเมื่อ Component โหลด
  }
  GetProfile = async () => {
      const result = await GET("admin/users/profile", null, false);
      if (result?.status) {
        localStorage.setItem("cm-profile", JSON.stringify(result.data));
        this.setState({
          user_profile: result.data,
        });
      }
    };

 // 1. เพิ่ม method สำหรับดึงข้อมูลบริษัท
  GetCompanies = async () => {
  const result = await GET("console", null, false); 

  if (result?.status === true) {
    // ทำการ Map ข้อมูลจาก API ให้ตรงกับโครงสร้างที่ UI ต้องการ
    const mappedCompanies = result.data.map((item) => ({
      id: item.uid,               // Map uid เป็น id
      name: item.company_name,    // Map company_name เป็น name
      code: item.company_code,    // Map company_code เป็น code
      type: item.description,     // ใช้ description เป็น type
      logo: item.logo || null,    // มีโลโก้ก็แสดงแทนไอคอนตึก
      // คงค่าเริ่มต้นสำหรับ UI ไว้
      iconColor: "#cfe2ff",
      textColor: "#084298",
      icon: "\uf1ad",
    }));

    this.setState({ companies: mappedCompanies });
  } else {
    clearStorageKeepLang();
    alert("/", "warning", t("warning"), "Failed to fetch companies.");
    console.error("Failed to fetch companies or data format error:", result);
  }
};


  // 2. ปรับปรุง handleProceed ให้บันทึกลง localStorage
  handleProceed = () => {
    const { selectedCompany, user_profile } = this.state;
    if (!selectedCompany) return;

    // GetProfile พลาดและ localStorage ก็ว่าง -> ระบุตัวตนไม่ได้ ให้กลับไป login ใหม่
    // (เดิมจะ throw ที่ user_profile.user_type แล้วปุ่มเงียบไปเฉย ๆ)
    if (!user_profile) {
      clearStorageKeepLang();
      window.location.href = "/";
      return;
    }
    
    // บันทึกลง localStorage
    localStorage.setItem("cm-company", JSON.stringify(selectedCompany));
    
    // หากต้องการบันทึกสถานะการจำบริษัท (Remember Me)
    switch (user_profile.user_type) {
        case "super_user": window.location.href = `/portal`; return;
        case "admin-company": window.location.href = `/portal`; return;
        default: break;
    }

    // console.log("Proceeding to:", selectedCompany.name);

    // console.log("user_profile:", user_profile.role?.permission)

    const perms = user_profile.role?.permission || [];
    // โมดูลที่เข้าได้จริง = ผ่านทั้งการล็อกตาม user_type และ permission ของ role
    const module = global.getAccessibleModules(user_profile);
    const adminLink = global.getFirstAccessibleLink(global.menu_admin, perms);

    // ประเภทผู้ใช้ที่ถูกล็อกพอร์ทัล (ช่างเทคนิค = เข้าได้เฉพาะพอร์ทัลแอดมิน) เดินตาม step เดียวกับ user อื่น
    // คือผ่านหน้าเลือกพอร์ทัลเสมอ ให้เห็นว่าพอร์ทัลอื่นมีอยู่แต่ติดกุญแจ (portal.js เป็นคนล็อกการ์ดให้)
    if (global.PORTAL_LOCK_BY_USER_TYPE[user_profile.user_type]?.via_portal_page) {
        window.location.href = `/portal`;
        return;
    }

    // ผู้บริหาร/ผู้บังคับบัญชา ใช้ admin portal เป็นหลัก — เข้าตรงเสมอ ไม่ต้องผ่านหน้าเลือกพอร์ทัล
    // ถ้า role ไม่มีสิทธิ์เมนูแอดมินเลย ค่อยตกไปหน้าเลือกพอร์ทัล/พอร์ทัลที่เข้าได้ตามสิทธิ์
    if (["executive", "supervisor"].includes(user_profile.user_type)) {
        window.location.href = adminLink || global.getFirstAccessibleLink(global.menu_warehouse, perms) || global.getFirstAccessibleLink(global.menu_customer, perms) || "/forbidden";
        return;
    }

    if(module.length <= 1){
        switch (user_profile.user_type) {
            case "sales_manager":
            case "sales":
            case "admin": window.location.href = adminLink || "/forbidden"; break;
            case "customer": window.location.href = global.getFirstAccessibleLink(global.menu_customer, perms) || "/forbidden"; break;
            case "warehouse": window.location.href = global.getFirstAccessibleLink(global.menu_warehouse, perms) || "/forbidden"; break;
            default: window.location.href = "/forbidden"; break;
        }
    }else{
        switch (user_profile.user_type) {
            case "sales_manager":
            case "sales":
            case "admin": window.location.href = `/portal`; break;
            case "customer": window.location.href = `/portal`; break;
            case "warehouse": window.location.href = `/portal`; break;
            default: window.location.href = `/portal`; break;
        }
    }
    
  };

  handleSelectCompany = (company) => {
    this.setState({ selectedCompany: company });
  };

  handleClearSelection = () => {
    this.setState({ selectedCompany: null });
  };

  Logout = async () => {
  if (
         await alert(
                "",
                "warning",
                t("confirm"),
                t("logout_ask"),
                t("logout"),
                t("cancel"),
              )
      ) {
        loading(true);
        let result = await POST("auth/logout");
        if (result?.status) {
          clearStorageKeepLang();
          window.location.href = "/";
        }
        loading(false);
      }
      
    };
  

  render() {
    const { searchName, selectedCompany, companies, rememberMe, user_profile } = this.state;

    // กรองรายชื่อบริษัทตามคำค้นหา
    const filteredCompanies = companies.filter((c) => {
      const matchName = c.name.toLowerCase().includes(searchName.toLowerCase());
      return (searchName ? matchName : true);
    });

    return (
        <div
            className="min-vh-100 d-flex flex-column font-sans"
            style={{
                background: "linear-gradient(180deg, #1461bd 0%, #2985f2 100%)",
            }}
        >
            {/* Top Header */}
            <div className="container-fluid px-4 py-3 d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-center text-white">
                    <div className="bg-white rounded p-1 me-3 d-flex align-items-center justify-content-center shadow-sm" style={{ width: "45px", height: "45px" }}>
                        <img src={LOGO} alt="logo" className="img-fluid" style={{ maxHeight: "100%" }} />
                    </div>
                    <div>
                        <h5 className="mb-0 fw-bold">CMMS</h5>
                        <small className="opacity-75" style={{ fontSize: "0.8rem" }}>
                            Computerized Maintenance Management System
                        </small>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <Language />
                    </div>
                    <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: "var(--bs-gray-2)" }} />
                    <div className="d-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                        <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: "0.75rem" }}>
                            {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                        </span>
                        <div className="pe-2">
                            <div className="text-14 fw-semibold text-dark">{user_profile?.full_name || "Username"}</div>
                            <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                                {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                            </div>
                        </div>
                        <button className="btn btn-sm border-0 p-2 text-dark" style={{ opacity: 0.7 }} onClick={() => this.Logout()} title="Logout">
                            <span className="icon">{"\uf08b"}</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="container flex-grow-1 d-flex flex-column align-items-center justify-content-center mb-5">
                {/* Titles */}
                <div className="text-center text-white mb-4">
                    <h2 className="fw-bold mb-2">เลือกบริษัทของคุณ</h2>
                    <p className="opacity-75">เลือกบริษัทเพื่อเข้าใช้งานระบบ CMMS</p>
                </div>

                {/* Main Card */}
                <div className="card border-0 rounded-4 shadow-lg p-4 p-md-5 w-100" style={{ maxWidth: "800px" }}>
                    {/* Search Inputs */}
                    <input type="text" className="form-control mb-4" placeholder="Search company name..." value={searchName} onChange={(e) => this.setState({ searchName: e.target.value })} />

                    {/* List Header */}
                    <div className="d-flex align-items-center mb-3">
                        <span className="icon me-2 text-muted">{"\uf0ca"}</span>
                        <span className="text-muted fw-bold" style={{ fontSize: "0.9rem" }}>
                            บริษัทที่สามารถเข้าใช้งานได้
                        </span>
                    </div>

                    {/* Company Grid */}
                    <div className="row g-3 mb-4">
                        {filteredCompanies.map((company) => {
                            const isSelected = selectedCompany?.id === company.id;
                            return (
                                <div className="col-md-6" key={company.id}>
                                    <div
                                        className={`rounded-4 h-100 p-3 cursor-pointer transition-hover ${isSelected ? "border-primary bg-primary-light" : "border-secondary"}`}
                                        style={{
                                            borderWidth: isSelected ? "2px" : "1px",
                                            boxShadow: isSelected ? "none" : "0 2px 4px rgba(0,0,0,0.02)",
                                        }}
                                        onClick={() => this.handleSelectCompany(company)}
                                    >
                                        <div className="d-flex align-items-center">
                                            <div
                                                className="rounded-3 d-flex align-items-center justify-content-center me-3"
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    // มีโลโก้ให้พื้นหลังเป็นขาว + เส้นขอบบางๆ โลโก้ส่วนใหญ่มีพื้นหลังของตัวเองอยู่แล้ว
                                                    backgroundColor: company.logo && !this.state.logoErrors[company.id] ? "#fff" : company.iconColor,
                                                    border: company.logo && !this.state.logoErrors[company.id] ? "1px solid #e2e8f0" : "none",
                                                    color: company.textColor,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {this.renderCompanyIcon(company, "32px")}
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="fw-bold mb-1 text-dark" style={{ fontSize: "0.95rem" }}>
                                                    {company.name}
                                                </h6>
                                                <div className="d-flex align-items-center text-muted" style={{ fontSize: "0.75rem" }}>
                                                    <span className="badge bg-light text-dark border me-2 font-monospace">{company.code}</span>
                                                    {company.type}
                                                </div>
                                            </div>
                                            {isSelected && (
                                                <div className="ms-2 text-primary">
                                                    <span className="icon fs-5">{"\uf058"}</span> {/* Check-circle icon */}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Selected Company Preview Box */}
                    {selectedCompany && (
                        <div className="rounded-3 p-3 mb-4 d-flex align-items-center justify-content-between" style={{ backgroundColor: "#f0f6ff", border: "1px solid #cce0ff" }}>
                            <div className="d-flex align-items-center">
                                <div
                                    className={`rounded-3 d-flex align-items-center justify-content-center me-3 ${selectedCompany.logo && !this.state.logoErrors[selectedCompany.id] ? "bg-white border" : "bg-primary text-white"}`}
                                    style={{ width: "35px", height: "35px", overflow: "hidden" }}
                                >
                                    {this.renderCompanyIcon(selectedCompany, "28px", { fontSize: "0.85rem" })}
                                </div>
                                <div>
                                    <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                                        บริษัทที่เลือก:
                                    </div>
                                    <div className="fw-bold text-dark" style={{ fontSize: "0.95rem" }}>
                                        {selectedCompany.name} ({selectedCompany.code})
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-sm btn-link text-muted p-0 text-decoration-none" onClick={this.handleClearSelection}>
                                <span className="icon fs-5">{"\uf00d"}</span> {/* Close icon */}
                            </button>
                        </div>
                    )}

                    {/* Proceed Button */}
                    <button
                        className={`btn w-100 py-3 fw-bold rounded-3 ${selectedCompany ? "btn-primary shadow-sm" : "bg-light text-muted border-0"}`}
                        disabled={!selectedCompany}
                        onClick={this.handleProceed}
                        style={{ transition: "all 0.2s" }}
                    >
                        ดำเนินการเข้าสู่ระบบ <span className="icon ms-2">{"\uf061"}</span>
                    </button>

                    {/* Remember Me Checkbox */}
                    <div className="text-center mt-3">
                        <div className="form-check form-check-inline m-0 cursor-pointer">
                            <input
                                className="form-check-input cursor-pointer shadow-none"
                                type="checkbox"
                                id="rememberSelection"
                                checked={rememberMe}
                                onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                            />
                            <label className="form-check-label text-muted cursor-pointer" style={{ fontSize: "0.85rem" }} htmlFor="rememberSelection">
                                จดจำการเลือกบริษัทของฉัน
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            {/* System Management */}
            {user_profile?.user_type === "super_user" && (
                <div className="container mb-5">
                    <div className="text-center mb-3">
                        <h4 className="text-white fw-bold">{t("sys_manage")}</h4>
                        <div className="border-bottom border-white w-25 mx-auto mt-2"></div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div className="card border-0 rounded-4 shadow-sm p-2 cursor-pointer transition-hover" onClick={() => (window.location.href = "/su/companies")}>
                                <div className="card-body d-flex align-items-center">
                                    <div className="bg-dark rounded-3 d-flex align-items-center justify-content-center me-3" style={{ width: "50px", height: "50px" }}>
                                        <span className="icon text-white text-24">{"\uf1ad"}</span>
                                    </div>
                                    <div className="flex-grow-1">
                                        <h6 className="fw-bold text-dark mb-1">{t("manage_comp")}</h6>
                                        <p className="text-muted small mb-0" style={{ fontSize: "0.8rem" }}>
                                            {t("manage_comp_desc")}
                                        </p>
                                    </div>
                                    <div className="ms-3 text-muted">
                                        <span className="icon">{"\uf061"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Footer */}
            <div className="text-center text-white pb-4 mt-auto">
                <div className="mb-3" style={{ fontSize: "0.85rem" }}>
                    <span className="icon me-2">{"\uf059"}</span>
                    ต้องการความช่วยเหลือ?{" "}
                    <a href="#" className="text-white text-decoration-underline">
                        ติดต่อฝ่ายสนับสนุน
                    </a>
                </div>
                <small className="opacity-80" style={{ fontSize: "0.75rem" }}>
                    CMMS Version {global.version} - Multi-Company Edition
                </small>
            </div>
        </div>
    );
  }
}